import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export type TSelectableElement = {
    $selected?: boolean,
    disabled?: boolean,
}

interface ISelectableWrapperProps extends TSelectableElement {
    children: ReactNode | ReactNode[] | string,
}

const SelectableWrapper = ({
    children,
    ...props
}: ISelectableWrapperProps): JSX.Element => {
    return <div {...props}>{children}</div>;
};

const SelectableElement = styled(SelectableWrapper)<TSelectableElement>`
    display: block;
    border-radius: 20px;
    cursor: pointer;
    border: 2px solid transparent;
    padding: 2px;

    & > * {
        background-color: ${COLORS.BgSubstrate};
        border-radius: ${BorderRadius.componentRadius};
    }

    ${FONTS.S};

    ${({ $selected }) => $selected
            ? css`
                & > * {
                    background-color: ${COLORS.BgMain};
                }

                border-color: ${COLORS.Brand_Blue};
                font-weight: bold;

                ${FONTS.MediumS};
            `
            : ''
    }

    ${({ disabled }) => disabled
            ? css`
                pointer-events: none;
                color: ${COLORS.TextDisabled};
            `
            : ''
    }
`;

export default SelectableElement;
